import { type UUID } from '~/types/common';

import { useQueryVehiclesInfinite } from '~/data/vehicle';

import { MultiItemsManager } from './MultiItemsManager';

const selectVehicles = (data) =>
  data?.map(({ id, licensePlate }) => ({
    id,
    name: licensePlate,
  }));

type P = {
  readonly filterActive?: boolean | null;
  readonly isCreatingNewEntity?: boolean;
  readonly isDisabled?: boolean;
  readonly label?: string;
  readonly onChange?: (selectedIds: UUID[]) => void;
  readonly onSaveSelection?: () => void;
  readonly onSelectedItemClick?: (id: UUID) => void;
  readonly parentOrganizationalUnitId?: UUID;
};

export const MultiItemsManagerVehicles = ({
  filterActive = true,
  isCreatingNewEntity = false,
  isDisabled = false,
  label = 'Fahrzeuge',
  onChange,
  onSaveSelection,
  onSelectedItemClick,
  parentOrganizationalUnitId,
}: P) => {
  const useGetterFunctionSelectedItems = (searchString: string) => {
    const query = useQueryVehiclesInfinite({
      filterActive: filterActive ?? undefined,
      filterParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

    if (!isCreatingNewEntity) {
      return query;
    }

    return {
      data: [],
      fetchNextPage() {},
      hasNextPage: false,
      isFetchingNextPage: false,
      isLoading: false,
      totalCount: 0,
    };
  };

  const useGetterFunctionSelectableItems = (searchString: string) =>
    useQueryVehiclesInfinite({
      filterActive: filterActive ?? undefined,
      filterNotParentOu: parentOrganizationalUnitId ?? undefined,
      searchString,
    });

  return (
    <MultiItemsManager
      fieldName="name"
      getterFunctionSelectableItems={useGetterFunctionSelectableItems}
      getterFunctionSelectedItems={useGetterFunctionSelectedItems}
      isDisabled={isDisabled}
      label={label}
      selectFunctionSelectableItems={selectVehicles}
      selectFunctionSelectedItems={selectVehicles}
      onChange={onChange}
      onSaveSelection={onSaveSelection}
      onSelectedItemClick={onSelectedItemClick}
    />
  );
};
